// --- IMPORTACIONES Y ESTADO ---
import { useState, useEffect } from 'react';
import {
  Container, Row, Col, Spinner, Modal, Form, Button,
  ListGroup, Badge, Carousel, Alert
} from 'react-bootstrap';
import { AnimatePresence, motion } from 'framer-motion';
import { db, auth } from '../firebase';
import {
  collection, query, where, onSnapshot,
  deleteDoc, doc, getDocs
} from "firebase/firestore";
import { onAuthStateChanged } from 'firebase/auth';
import { FaShoppingCart, FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ReceiptModal from '../components/ReceiptModal';

const categoryFilters = [
  { name: "Todos", image: "https://hard-drive.net/wp-content/uploads/2024/07/Screenshot-2024-07-29-at-8.25.56%E2%80%AFPM.jpg.webp" },
  { name: "Pokemon", image: "https://firebasestorage.googleapis.com/v0/b/arzu-9380c.firebasestorage.app/o/Botones%2FBoton%20Pokemon.png?alt=media&token=27c0f267-876e-49b1-aa90-530f811cc5e0" },
  { name: "OnePiece", image: "https://aura-print.com/media/wysiwyg/One-piece-tcg-starting-banner_1.jpg" },
  { name: "Shadowverse Evolve", image: "https://firebasestorage.googleapis.com/v0/b/arzu-9380c.firebasestorage.app/o/Botones%2FBoton%20Shadowverse.png?alt=media&token=3f1cb7c4-c8b7-4f94-91d2-a41cf5253c0d" },
  { name: "Digimon", image: "https://firebasestorage.googleapis.com/v0/b/arzu-9380c.firebasestorage.app/o/Botones%2FBoton%20Digimon.png?alt=media&token=0f7ca82a-5500-4585-9cc3-2896c936f040" },
  { name: "Grand archive", image: "https://firebasestorage.googleapis.com/v0/b/arzu-9380c.firebasestorage.app/o/Botones%2FBoton%20Grand%20Archive.png?alt=media&token=80451270-3da9-4642-92e6-77176ad15def" },
  { name: "Weisschwarz", image: "https://firebasestorage.googleapis.com/v0/b/arzu-9380c.firebasestorage.app/o/Botones%2FBoton%20weis.png?alt=media&token=f22e84b4-2ace-4167-aa2c-e6ac1a3b3281" },
  { name: "vanguard", image: "https://firebasestorage.googleapis.com/v0/b/arzu-9380c.firebasestorage.app/o/Botones%2FBoton%20Vanguard.png?alt=media&token=14931e84-cac1-4a91-8beb-74c82b4995b5" },
  { name: "Accesorios", image: "https://m.media-amazon.com/images/S/abs-image-upload-na/f/AmazonStores/ATVPDKIKX0DER/8d577e687a800df8a3729cfd5681b74f.w6746.h3794.jpg" }
];

const pickupOptions = [...['ArzúBC','ArzúSF','ArzúHeredia','ArzúAlajuela'], "Envíos de Costa Rica"];
const STORES = ['ArzúBC', 'ArzúSF', 'ArzúHeredia', 'ArzúAlajuela'];

const normalizeStr = (str) => {
  if (typeof str !== "string") return "";


  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
};
const Catalog = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [buyerName, setBuyerName] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
const [showReceiptModal, setShowReceiptModal] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [storeStocks, setStoreStocks] = useState({});
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [transaction, setTransaction] = useState(null);

  const [currentUser, setCurrentUser] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const cartTotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);


  const handlePaymentSubmit = (e) => {
    e.preventDefault();
  
    const fakeAuthCode = 'AUTH' + Math.floor(100000 + Math.random() * 900000);
    const transactionData = {
      id: 'TXN' + Date.now(),
      buyerName: buyerName || currentUser?.displayName || 'Usuario Invitado',
      date: Date.now(),
      amount: cartTotal,
      currency: 'CRC',
      authorizationCode: fakeAuthCode,
      merchantName: 'Arzú Store'
      
    };
  
    setTransaction(transactionData);
    setShowReceiptModal(true);

    setShowCartModal(false);
    setShowPaymentModal(false);
    setCartItems([]);
  };
  
  

  const [shippingAddress, setShippingAddress] = useState({
    provincia: "",
    canton: "",
    distrito: "",
    direccion: "",
    telefono: "",
    codigoPostal: ""
  });

  const [preorders, setPreorders] = useState([]);
  const [showPreorders, setShowPreorders] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => setCurrentUser(user));
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const q = collection(db, "inventoryProducts");
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const productsData = snapshot.docs
        .map(doc => ({
          id: doc.id,
          name: doc.data().nombre,
          description: doc.data().descripcion,
          price: doc.data().precioPublico,
          image: doc.data().imageURL,
          category: doc.data().categoria,
          activo: doc.data().activo
        }))
        .filter(product => product.activo && Object.values(product.activo).some(val => val === true));
      setProducts(productsData);
      setFilteredProducts(productsData);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const normalizedSelected = normalizeStr(selectedCategory);
    const filtered = selectedCategory === "Todos"
      ? products
      : products.filter(p => normalizeStr(p.category) === normalizedSelected);

    const finalFiltered = filtered.filter(product =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredProducts(finalFiltered);
  }, [selectedCategory, products, searchTerm]);

  const fetchStock = async (product) => {
    const stocks = {};
    for (const store of STORES) {
      if (product.activo && product.activo[store]) {
        const q = query(
          collection(db, 'stores', store, 'inventario'),
          where('productId', '==', product.id)
        );
        const snapshot = await getDocs(q);
        stocks[store] = snapshot.docs.reduce((acc, doc) => acc + doc.data().cantidad, 0);
      } else {
        stocks[store] = 0;
      }
    }
    return stocks;
  };

  useEffect(() => {
    const loadStock = async () => {
      if (!selectedProduct) return;
      const stocks = await fetchStock(selectedProduct);
      setStoreStocks(stocks);
    };
    if (showProductModal) {
      loadStock();
    }
  }, [showProductModal, selectedProduct]);

  const handleAddToCart = () => {
    if (!selectedStore) {
      setToastMessage({ text: "Seleccione una tienda para recoger.", type: "warning" });

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    alert("Pago procesado con éxito 🛒");
    setShowCartModal(false);
    setShowPaymentModal(false);
    setCartItems([]);
    const fakeAuthCode = 'AUTH' + Math.floor(100000 + Math.random() * 900000);
    setTransaction({
      id: 'TXN' + Date.now(),
      buyerName: currentUser?.displayName || 'Usuario Invitado',
      date: Date.now(),
      amount: cartTotal,
      currency: 'CRC',
      authorizationCode: fakeAuthCode,
      merchantName: 'Arzú Store'
    });
    setCartItems([]);
    setShowCartModal(false);
    setShowPaymentModal(false);
  };

      return;
    }
    const cartItem = {
      ...selectedProduct,
      store: selectedStore,
      quantity: Number(selectedQuantity)
    };
    setCartItems(prev => {
      const existingIndex = prev.findIndex(item => item.id === selectedProduct.id && item.store === selectedStore);
      if (existingIndex !== -1) {
        const updatedItems = [...prev];
        updatedItems[existingIndex].quantity += Number(selectedQuantity);
        return updatedItems;
      }
      return [...prev, cartItem];
    });
    setToastMessage({ text: `Producto añadido al carrito (${selectedStore})`, type: "success" });
    setShowProductModal(false);
    setSelectedStore("");
    setSelectedQuantity(1);
  };

  const renderToast = () => toastMessage && (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      className={`toast align-items-center text-white ${toastMessage.type === "success" ? "bg-success" : "bg-warning"} border-0 position-fixed top-0 end-0 m-3`}
      style={{ zIndex: 1100 }}
      role="alert"
    >
      <div className="d-flex">
        <div className="toast-body">
          {toastMessage.text}
        </div>
        <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setToastMessage(null)}></button>
      </div>
    </motion.div>
  );

  useEffect(() => {
    const fetchPreorders = async () => {
      const preordersSnapshot = await getDocs(collection(db, "preorders"));
      const preordersData = preordersSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPreorders(preordersData);
    };

    fetchPreorders();
  }, []);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setShowPreorders(false);
  };

  const handleShowPreorders = () => {
    setShowPreorders(true);
  };

  return (

    <>
    <ReceiptModal
  show={showReceiptModal}
  onHide={() => setShowReceiptModal(false)}
  transaction={transaction}
/>

      {renderToast()}

      {/* Botón flotante de carrito */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 1000
        }}
      >
        <Button
          variant="light"
          onClick={() => setShowCartModal(true)}
          style={{
            borderRadius: '50%',
            width: '70px',
            height: '70px',
            padding: 0,
            fontSize: '22px',
            border: '2px solid #00C2FF'
          }}
        >
          <FaShoppingCart size={30} />
          {cartItems.length > 0 && (
            <Badge bg="dark" style={{ position: 'absolute', top: 0, right: 0 }}>
              {cartItems.length}
            </Badge>
          )}
        </Button>
      </motion.div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="section">
        <Container>
          <h2 className="section-title text-center mb-4">Nuestro Catálogo</h2>

          {/* Barra de búsqueda discreta */}
          <Form.Group className="mb-4">
            <Form.Control
              type="text"
              placeholder="Buscar productos..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                borderRadius: '20px',
                padding: '10px 20px',
                border: '1px solid #ccc',
                fontStyle: 'italic',
                fontSize: '0.9rem'
              }}
            />
          </Form.Group>

          <Row className="g-3 mb-4">
            {categoryFilters.map(filter => (
              <Col key={filter.name} xs={6} md={3}>
                <motion.div 
                  whileHover={{ scale: 1.05 }} 
                  onClick={() => handleCategoryClick(filter.name)}
                  className={`category-filter p-2 rounded-3 text-center ${selectedCategory === filter.name && !showPreorders ? 'border border-2' : ''}`}
                  style={{
                    cursor: "pointer",
                    background: "#f8f9fa",
                    borderColor: "#00C2FF"
                  }}
                >
                  <img 
                    src={filter.image} 
                    alt={filter.name}
                    className="img-fluid rounded"
                    style={{ width: "100%", height: "100px", objectFit: "cover" }}
                  />
                </motion.div>
              </Col>
            ))}
            {/* Botón de Pre-ordenes */}
            <Col xs={6} md={3}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                onClick={handleShowPreorders}
                className={`category-filter p-2 rounded-3 text-center ${showPreorders ? 'border border-2' : ''}`}
                style={{ cursor: "pointer", background: "#f8f9fa", borderColor: "#00C2FF" }}
              >
                <span>Pre-ordenes</span>
              </motion.div>
            </Col>
          </Row>
          <Row className="g-4">
            <AnimatePresence>
              {loading ? (
                <Spinner animation="border" variant="primary" className="mx-auto" />
              ) : showPreorders ? (
                preorders.map(preorder => (
                  <Col key={preorder.id} lg={4} md={6}>
                    <motion.div
                      layout
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                      className="product-card rounded-3 overflow-hidden position-relative"
                      style={{ cursor: "pointer", border: "2px solid #00C2FF" }}
                    >
                      <img
                        src={preorder.imageURL1}
                        alt={preorder.name}
                        className="img-fluid w-100"
                        style={{ height: '300px', objectFit: 'cover' }}
                      />
                      <div className="p-4">
                        <h3 className="h5 mb-3">{preorder.name}</h3>
                        <p className="text-muted small mb-3">{preorder.description}</p>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="h5 text-primary">₡{preorder.price?.toLocaleString()}</span>
                          <span className="text-muted small">Lanzamiento: {new Date(preorder.releaseDate).toLocaleDateString()}</span>
                        </div>
                      </div>
                    </motion.div>
                  </Col>
                ))
              ) : (
                filteredProducts.map(product => (
                  <Col key={product.id} lg={4} md={6}>
                    <motion.div
                      layout
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                      className="product-card rounded-3 overflow-hidden position-relative"
                      style={{
                        cursor: "pointer",
                        border: "2px solid #00C2FF"
                      }}
                      onClick={() => {
                        setSelectedProduct(product);
                        setShowProductModal(true);
                        setSelectedQuantity(1);
                        {currentUser && (
                          <Button
                            variant="danger"
                            size="sm"
                            style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}
                            onClick={async (e) => {
                              e.stopPropagation();
                              const confirmDelete = window.confirm(`¿Estás seguro de eliminar "${product.name}"?`);
                              if (confirmDelete) {
                                try {
                                  await deleteDoc(doc(db, "inventoryProducts", product.id));
                                  setToastMessage({ text: "Producto eliminado exitosamente", type: "success" });
                                } catch (error) {
                                  console.error("Error eliminando producto:", error);
                                  setToastMessage({ text: "Error al eliminar el producto", type: "warning" });
                                }
                              }
                            }}
                          >
                            Eliminar
                          </Button>
                        )}

                      }}

            
                    >
                      <img 
                        src={product.image} 
                        alt={product.name}
                        className="img-fluid w-100"
                        style={{ height: '300px', objectFit: 'cover' }}
                      />
                      <div className="p-4">
                        <h3 className="h5 mb-3">{product.name}</h3>
                        {product.description && (
                          <p className="text-muted small mb-3">{product.description}</p>
                        )}
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="h5 text-primary">₡{product.price?.toLocaleString()}</span>
                        </div>
                      </div>
                    </motion.div>
                  </Col>
                ))
              )}
            </AnimatePresence>
          </Row>
        </Container>
      </motion.div>

      {/* Modal de producto */}
      <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" style={{ border: '2px solid #00C2FF' }}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={selectedProduct?.image}
                    alt="Imagen del producto"
                    style={{ maxHeight: '400px', objectFit: 'contain' }}
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
            <Col md={6}>
              <h4 className="mb-3">₡{selectedProduct?.price?.toLocaleString()}</h4>
              <p className="text-muted">{selectedProduct?.description}</p>
              <Form>
              <Form.Group className="mb-3">
  <Form.Label>Nombre del Comprador</Form.Label>
  <Form.Control
    type="text"
    value={buyerName}
    onChange={(e) => setBuyerName(e.target.value)}
    required
    placeholder="Ej. Juan Pérez"
  />
</Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Recoger en:</Form.Label>
                  <Form.Select value={selectedStore} onChange={(e) => setSelectedStore(e.target.value)}>
                    <option value="">Seleccione una tienda</option>
                    {pickupOptions.map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Acepto los términos y condiciones"
                    required
                  />
                </Form.Group>
                <Button
                  style={{ backgroundColor: '#00C2FF', borderColor: '#00C2FF' }}
                  onClick={handleAddToCart}
                >
                  Añadir al Carrito
                </Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* Modal del carrito */}
      <Modal show={showCartModal} onHide={() => setShowCartModal(false)} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>🛒 Tu carrito</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {cartItems.length === 0 ? (
      <p className="text-center">Tu carrito está vacío.</p>
    ) : (
      <>
        <ListGroup variant="flush">
          {cartItems.map((item, idx) => (
            <ListGroup.Item key={idx} className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-3">
                <img src={item.image} alt={item.name} width="60" className="rounded" />
                <div>
                  <strong>{item.name}</strong>
                  <div className="text-muted small">{item.quantity} unidad(es) - {item.store}</div>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <span className="fw-bold">₡{(item.price * item.quantity).toLocaleString()}</span>
                <Button variant="outline-danger" size="sm" onClick={() => {
                  const updated = cartItems.filter((_, i) => i !== idx);
                  setCartItems(updated);
                }}>
                  <FaTrashAlt />
                </Button>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <div className="text-end mt-4">
          <h5>Total: <strong>₡{cartTotal.toLocaleString()}</strong></h5>
          <Button
            size="lg"
            className="mt-3 w-100"
            onClick={() => navigate('/PowerTranzTest')}
            style={{ backgroundColor: '#00C2FF', borderColor: '#00C2FF' }}
          >
            Ir al pago seguro
          </Button>
        </div>
      </>
    )}
  </Modal.Body>
</Modal>
    </>
  );
};

export default Catalog;

